var $ = require('jquery');
// var matchHeight = require("jquery-match-height")
import { imageModal } from './modal.js'

$(document).ready(function() {
    initGallery();
})

$(window).on('load', function() {
    setTimeout(function() {
        setGalleryHeight();
    }, 1000);
})

$(window).on('resize', function() {
    setGalleryHeight();
})
function initGallery() {
    $('.wp-block-gallery .wp-block-image a').on('click', function(e) {
        e.preventDefault();
        var caption = $(this).next().text();
        var link = $(this).attr('href');
        imageModal(link, caption);
    });
}
function setGalleryHeight() {
    var biggestHeight = 0;
    // $('.wp-block-gallery .wp-block-image').matchHeight({
    //     byRow: false,
    // });
    // $('.wp-block-gallery .wp-block-image').each(function(e) {
    //     $(this).css('height', 'auto');
    //     var height = $(this).height();
    //     biggestHeight = Math.max(biggestHeight, height);
    // }).height(biggestHeight);

    // On mobile
    if(window.innerWidth <= 781) {
        // $('.wp-block-gallery .wp-block-image').matchHeight({remove: true,});
        // $('.wp-block-gallery .wp-block-image').each(function(e) {
        //     $(this).css('height', 'auto');
        // });
    }
    
}